import { createSelector } from 'reselect';

export const NotificationData = (state) => state.notification;

export const getListNotification = createSelector(NotificationData, (data) => {
  return data?.notifications ?? [];
});

export const getCountNotification = createSelector(NotificationData, (data) => {
  return data?.count ?? 0;
});
